'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdWbAuto = function MdWbAuto(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.2 26.6h3.1l-5.3-15h-3.4l-5.3 15h3.2l1.2-3.2h5.3z m19.4-15h3.1l-3.5 15h-2.8l-2.5-10.1-2.5 10.1h-3l-0.2-0.7c-2.2 4.4-6.6 7.5-11.8 7.5-7.4 0-13.4-6.1-13.4-13.4s6-13.4 13.4-13.4c4.2 0 7.9 2 10.3 5h1.3l2 10.6 2.5-10.6h2.7l2.5 10.6z m-25.2 9.5l2-6.1 1.8 6.1h-3.8z' })
        )
    );
};

exports.default = MdWbAuto;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/wb-auto.js
// module id = 2072
// module chunks = 168707334958949